// extracted by mini-css-extract-plugin
export default {"deleteButton":"_1Big3UoMZR3qtso2bi-tjk","addButton":"_3OXI-1o7FW2eeuhx-P39M5","filterButton":"_4RTBrN2GK3XBc32I_RPJ","applyButton":"_3Et5HoqDOKnvxfLE8m1osq"};